import { CheckCircle2, Copy, Loader2, XCircle, type LucideIcon } from 'lucide-react';

import type { QueueStats } from '@repo/types';
import { StatCard } from '@/components/dashboard/StatCard';

interface ScrapingQueueStatsProps {
  stats: QueueStats;
}

// "Pending" is dropped — the automated pipeline never dwells there. In its place,
// "Job Clashes" surfaces postings that were re-scraped but already existed
// (skipped). The smaller "duplicate → draft" count stays on the row-level badge.
interface Tile {
  label: string;
  icon: LucideIcon;
  value: (s: QueueStats) => number;
  sublabel?: string;
}

const TILES: Tile[] = [
  { label: 'Job Clashes', icon: Copy, value: (s) => s.exists ?? 0, sublabel: '(Already Existed)' },
  { label: 'Processing', icon: Loader2, value: (s) => s.processing },
  { label: 'Completed', icon: CheckCircle2, value: (s) => s.completed },
  { label: 'Failed', icon: XCircle, value: (s) => s.failed },
];

export function ScrapingQueueStats({ stats }: ScrapingQueueStatsProps) {
  return (
    // items-stretch (grid default) + h-full keeps every card the same height even
    // though only "Job Clashes" carries a sublabel.
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      {TILES.map((tile) => (
        <StatCard
          key={tile.label}
          label={tile.label}
          sublabel={tile.sublabel}
          value={tile.value(stats)}
          icon={tile.icon}
          className="h-full"
        />
      ))}
    </div>
  );
}
